import {Tooltip} from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import type {FC} from 'react'
import {NavLink} from 'react-router-dom'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import type {CockpitWarningInterface} from '@shared/interfaces/cockpitWarning'

type Props = {
  warnings: CockpitWarningInterface[]
  lineId?: string
  equipmentId?: string
}

const CardWarning: FC<Props> = ({warnings, lineId, equipmentId}) => {
  const [t] = useCustomTranslation('lines_overview')

  const generateLink = (): string => {
    if (lineId) {
      return `/?tab=cockpit&element_id=${lineId}&element_type=machine&panelOpen=true`
    }
    if (equipmentId) {
      return `/?tab=cockpit&element_id=${equipmentId}&element_type=machinesubsystem&panelOpen=true`
    }
    return '/'
  }

  const tooltipTitle = (): string =>
    warnings.length > 1
      ? `${warnings.length} ${t('warnings')}`
      : `${warnings.length} ${t('warning')}`

  return (
    <NavLink
      to={generateLink()}
      style={{textDecoration: 'none'}}
      data-testid="navlink-card-warning"
    >
      <Tooltip title={tooltipTitle()}>
        <WarningIcon sx={{color: 'primary.main'}} />
      </Tooltip>
    </NavLink>
  )
}

export default CardWarning
